import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Truck } from "lucide-react";

const KlarnaCard = () => (
  <Link to="/catalogo" className="lt-promo group relative overflow-hidden rounded-[2rem] bg-[#FFB3C7] p-8 text-[#0A0B0E] sm:p-10" data-testid="promo-klarna-banner">
    <span className="lt-promo-shine" />
    <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/30 blur-2xl lt-float" />
    <span className="inline-flex rounded-lg bg-[#0A0B0E] px-3 py-1 text-sm font-extrabold text-[#FFB3C7]">Klarna.</span>
    <h3 className="mt-6 max-w-sm font-display text-3xl font-bold leading-tight tracking-[-0.03em] sm:text-4xl">PAGA IN COMODE RATE CON KLARNA!</h3>
    <div className="mt-6 flex gap-2" aria-hidden="true">
      {["1ª rata", "2ª rata", "3ª rata"].map((r, i) => (
        <span key={r} className="lt-chip rounded-full bg-white/70 px-4 py-1.5 text-xs font-semibold" style={{ animationDelay: `${i * 0.35}s` }}>{r}</span>
      ))}
    </div>
    <p className="mt-6 text-xs text-[#0A0B0E]/70">Per gli acquisti idonei, soggetto ad approvazione di Klarna.</p>
    <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold">Scopri i prodotti <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
  </Link>
);

const ShippingCard = () => (
  <Link to="/pagina/spedizioni" className="lt-promo group relative overflow-hidden rounded-[2rem] bg-[#0066FF] p-8 text-white sm:p-10" data-testid="promo-shipping-banner">
    <span className="lt-promo-shine" />
    <span className="inline-flex items-center gap-2 rounded-lg bg-white/15 px-3 py-1 text-sm font-semibold"><MapPin className="h-4 w-4" />Italia</span>
    <h3 className="mt-6 max-w-sm font-display text-3xl font-bold leading-tight tracking-[-0.03em] sm:text-4xl">SPEDIZIONE GRATUITA IN TUTTA ITALIA!</h3>
    <div className="relative mt-8 h-10" aria-hidden="true">
      <div className="absolute inset-x-0 bottom-1 border-t-2 border-dashed border-white/40 lt-road" />
      <Truck className="lt-truck absolute bottom-2 h-8 w-8" />
    </div>
    <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold">Dettagli spedizione <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
  </Link>
);

export const HomePromos = () => (
  <section className="mx-auto grid max-w-7xl gap-5 px-4 pt-14 sm:px-6 md:grid-cols-2" data-testid="home-promos">
    <KlarnaCard />
    <ShippingCard />
  </section>
);
